<template lang="pug">

.offer-div(:class="{offerSelected : reply2.bestOffer}")
  div.ribbon.ribbon-top-right(v-if="reply2.bestOffer")
    div
      <svg class="svg-badge-ico" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="35" height="35" viewBox="0 0 172 172" style=" fill:#000000;"><g fill="none" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt" stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0" font-family="none" font-weight="none" font-size="none" text-anchor="none" style="mix-blend-mode: normal"><path d="M0,172v-172h172v172z" fill="none"></path><g fill="#f9b330"><path d="M86.36281,6.88c-0.81969,0 -1.65281,0.28219 -2.31125,0.87344l-9.87656,8.815l-12.94031,-2.86219c-1.72,-0.37625 -3.45344,0.59125 -4.00437,2.27094l-4.15219,12.5775l-12.61781,3.99094c-1.69313,0.52406 -2.70094,2.24406 -2.35156,3.9775l2.70094,12.96719l-8.94937,9.75562c-1.19594,1.31688 -1.20938,3.30563 -0.02688,4.6225l8.815,9.87656l-2.86219,12.94031c-0.38969,1.72 0.59125,3.45344 2.27094,4.00437l12.5775,4.15219l3.9775,12.63125c0.5375,1.67969 2.2575,2.6875 3.9775,2.33812l12.98063,-2.70094l9.75562,8.94937c0.65844,0.59125 1.505,0.90031 2.33813,0.90031c0.80625,0 1.62594,-0.29562 2.28437,-0.87344l9.87656,-8.815l12.94031,2.86219c1.72,0.37625 3.45344,-0.60469 4.00437,-2.27094l4.13875,-12.5775l12.63125,-3.9775c1.69313,-0.5375 2.70094,-2.2575 2.35156,-3.9775l-2.70094,-12.98063l8.94937,-9.75562c1.19594,-1.31688 1.20938,-3.30563 0.02688,-4.6225l-8.815,-9.87656l2.86219,-12.94031c0.38969,-1.72 -0.60469,-3.45344 -2.27094,-4.00437l-12.5775,-4.15219l-3.99094,-12.63125c-0.5375,-1.67969 -2.24406,-2.67406 -3.9775,-2.33813l-12.96719,2.70094l-9.75562,-8.94937c-0.65844,-0.59125 -1.49156,-0.90031 -2.31125,-0.90031zM86,24.08c20.86844,0 37.84,16.97156 37.84,37.84c0,20.86844 -16.97156,37.84 -37.84,37.84c-20.86844,0 -37.84,-16.97156 -37.84,-37.84c0,-20.86844 16.97156,-37.84 37.84,-37.84zM86,30.96c-17.07906,0 -30.96,13.88094 -30.96,30.96c0,17.07906 13.88094,30.96 30.96,30.96c17.07906,0 30.96,-13.88094 30.96,-30.96c0,-17.07906 -13.88094,-30.96 -30.96,-30.96zM71.52781,114.55469l-9.5675,1.98875c-0.67188,0.13438 -1.35719,0.20156 -2.0425,0.20156c-1.74688,0 -3.41313,-0.43 -4.87781,-1.22281v46.15781c0,1.19594 0.61813,2.29781 1.62594,2.92938c1.02125,0.63156 2.28438,0.67187 3.35938,0.14781l25.97469,-12.99406l25.97469,12.99406c0.49719,0.24188 1.02125,0.36281 1.54531,0.36281c0.63156,0 1.26313,-0.17469 1.81406,-0.51062c1.00781,-0.63156 1.62594,-1.73344 1.62594,-2.92938v-46.17125c-1.59906,0.99438 -3.48031,1.58563 -5.46906,1.58563c-0.72562,0 -1.46469,-0.08063 -2.21719,-0.24188l-9.50031,-2.09625l-7.25625,6.47688c-1.89469,1.67969 -4.32687,2.60687 -6.85312,2.60687c-2.59344,0 -5.06594,-0.95406 -6.97406,-2.70094z"></path></g></g></svg>
      //- <svg class="svg-badge-ico" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="35" height="35" viewBox="0 0 172 172" style=" fill:#000000;"><g fill="none" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt" stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0" font-family="none" font-weight="none" font-size="none" text-anchor="none" style="mix-blend-mode: normal"><path d="M0,172v-172h172v172z" fill="none"></path><g><path d="M139.75,154.08333h-24.33083l-13.93917,17.37917l-22.93333,-53.2125h44.68417z" fill="#dd2c00"></path><path d="M97.395,118.25l-23.29167,53.2125l-13.93917,-17.37917h-24.33083l16.51917,-35.83333z" fill="#ff3d00"></path><path d="M144.49792,80.969c-1.96008,-3.55825 -1.96008,-7.87617 0,-11.43442l0.93883,-1.70567c3.06375,-5.57208 1.19325,-12.57392 -4.25342,-15.867l-1.66625,-1.0105c-3.47583,-2.107 -5.633,-5.84083 -5.719,-9.90075l-0.043,-1.94933c-0.129,-6.36042 -5.25317,-11.48458 -11.61358,-11.61358l-1.94933,-0.043c-4.0635,-0.08242 -7.80092,-2.24317 -9.90075,-5.719l-1.0105,-1.66625c-3.29308,-5.44308 -10.29492,-7.31717 -15.867,-4.25342l-1.70567,0.93883c-3.55825,1.96008 -7.87617,1.96008 -11.43442,0l-1.70208,-0.93525c-5.57208,-3.06375 -12.57033,-1.18967 -15.86342,4.25342l-1.0105,1.66625c-2.107,3.47583 -5.84083,5.633 -9.90075,5.719l-1.94933,0.043c-6.36042,0.129 -11.48458,5.25317 -11.61358,11.61358l-0.043,1.94933c-0.08242,4.0635 -2.24317,7.80092 -5.719,9.90075l-1.66625,1.0105c-5.4395,3.29308 -7.31717,10.29492 -4.25342,15.867l0.93883,1.70567c1.96008,3.55825 1.96008,7.87617 0,11.43442l-0.93525,1.70208c-3.06375,5.57208 -1.19325,12.57392 4.25342,15.867l1.66625,1.0105c3.47583,2.107 5.633,5.84083 5.719,9.90075l0.043,1.94933c0.129,6.36042 5.25317,11.48458 11.61358,11.61358l1.94933,0.043c4.0635,0.08242 7.80092,2.24317 9.90075,5.719l1.0105,1.66625c3.29308,5.4395 10.29492,7.31717 15.867,4.25342l1.70567,-0.93883c3.55825,-1.96008 7.87617,-1.96008 11.43442,0l1.70567,0.93883c5.57208,3.06375 12.57392,1.19325 15.867,-4.25342l1.0105,-1.66625c2.107,-3.47583 5.84083,-5.633 9.90075,-5.719l1.94933,-0.043c6.36042,-0.129 11.48458,-5.25317 11.61358,-11.61358l0.043,-1.94933c0.08242,-4.0635 2.24317,-7.80092 5.719,-9.90075l1.66625,-1.0105c5.4395,-3.29308 7.31717,-10.29492 4.25342,-15.867z" fill="#ffa000"></path><path d="M85.99642,32.25c-23.74824,0 -43,19.25176 -43,43c0,23.74824 19.25176,43 43,43c23.74824,0 43,-19.25176 43,-43c0,-23.74824 -19.25176,-43 -43,-43z" fill="#ffb300"></path><path d="M86,121.83692c-25.68533,0 -46.58333,-20.898 -46.58333,-46.58333c0,-25.68533 20.89442,-46.58692 46.58333,-46.58692c25.68892,0 46.58333,20.898 46.58333,46.58333c0,25.68533 -20.898,46.58692 -46.58333,46.58692zM86,35.83333c-21.7365,0 -39.41667,17.68375 -39.41667,39.41667c0,21.73292 17.68375,39.41667 39.41667,39.41667c21.73292,0 39.41667,-17.68375 39.41667,-39.41667c0,-21.73292 -17.68375,-39.41667 -39.41667,-39.41667z" fill="#ffca28"></path><path d="M81.58533,96.7715l-16.88108,-16.254l4.9665,-5.16l11.58492,11.15133l26.359,-28.83508l5.289,4.8375z" fill="#ffecb3"></path></g></g></svg>
      span.badge-text {{$t('offer.instructions.best')}}
  b-row.mr-0.ml-0.mb-2(v-if="pending")
    b-col(md="6")
      //- Departure unconfirmed disclaimers
      b-row
        b-col(v-show="replyDepartureAtHome && !reply2.departure.confirmSupport")
          small.font-weight-bold.text-secondary
            | {{ $t('offer.instructions.departure.home.notConfirmed') }}
        b-col(v-show="departureAtHarbor && !reply2.departure.confirmSupport")
          small.font-weight-bold.text-secondary
            | {{ $t('offer.instructions.departure.harbor.notConfirmed') }}
    b-col(md="6")
      //- Arrival unconfirmed disclaimer
      b-row
        b-col(v-show="!reply2.arrival.confirmHarbor")
          small.font-weight-bold.text-secondary
            | {{ $t('offer.instructions.arrival.notConfirmed') }}

  b-row.mr-0.ml-0.mb-2
    //- DEPARTURE
    b-col.f-col(md="1")
      span.offer-title {{ $t('offer.instructions.no', { id: ('00' + (index + 1)).slice(-3) }) }}
    b-col(md="5")
      //- Departure addresses
      h6.mb-2.mt-2.mt-sm-0.title-adress(
        v-if="departureAtHome && reply2.departure.confirmSupport"
      ) {{ $t('offer.instructions.departure.home.shipment') }}
      h6.mb-2.mt-2.mt-sm-0.title-adress(v-else) {{ $t('offer.instructions.departure.harbor.shipment') }}
      .d-flex(v-if="departureAtHome && reply2.departure.confirmSupport")
        .add-content
          p.m-0 
            <b>{{ $t('form.address1') | dots($i18n.locale) }}</b> {{ transit.departure.address.address1 ? transit.departure.address.address1 + ', ' : ''}} {{ transit.departure.address.address2 ? transit.departure.address.address2 : '' }}
          p.m-0 
            <b>{{ $t('form.city') | dots($i18n.locale) }}</b>  {{ transit.departure.address.city }} {{ transit.departure.address.zipCode ? ', ' + transit.departure.address.zipCode  : '' }} 
          p.m-0
            <b>{{ $t('form.country') | dots($i18n.locale) }}</b> {{ country(transit.departure.address.country) }}
          p.m-0(v-if="transit.departure.date && reply2.departure.confirmPickUpDate")
            <b>{{ $t('offer.instructions.departure.home.departureAt') }}</b> {{ transit.departure.date | moment($i18n.locale) }}
          p.m-0(v-if="reply2.departure.depositDate && !reply2.departure.confirmPickUpDate")
            <b>{{ $t('offer.instructions.departure.home.departureAt') }}</b> {{ reply2.departure.depositDate | moment($i18n.locale) }}
      .d-flex(v-else-if="reply2.departure.confirmSupport")
        .add-content(v-if="reply2.departure.confirmSupport")
          p.m-0
            <b>{{ $t('form.harbor') | dots($i18n.locale) }}</b> {{ transit.departure.address.city }}
          p.m-0
            <b>{{ $t('form.country') | dots($i18n.locale) }}</b> {{ country(transit.departure.address.country) }}
          //- p.m-0(v-if="transit.departure.date && reply2.departure.confirmPickUpDate")
          //-   <b>{{ $t('offer.instructions.departure.harbor.departureAt') }}</b> {{ transit.departure.date | moment($i18n.locale) }}
          p.m-0(v-if="reply2.departure.depositDate && !reply2.departure.confirmPickUpDate")
            <b>{{ $t('offer.instructions.departure.harbor.departureAt') }}</b> {{ reply2.departure.depositDate | moment($i18n.locale) }}
          //- .d-flex.m-0(v-if="reply && reply2.departure.harborInstruction")
          //-   <b>{{ $t('offer.instructions.departure.dropOff') | dots($i18n.locale) }}</b>  {{ reply2.departure.harborInstruction }}
      .d-flex(v-else)
        .add-content
          p.m-0
            <b>{{ $t('form.harbor') | dots($i18n.locale) }}</b> {{ reply2.departure.harbor.city}}
          p.m-0
            <b>{{ $t('form.country') | dots($i18n.locale) }}</b> {{ country(reply2.departure.harbor.country) }}
          p.m-0(v-if="transit.departure.date && reply2.departure.confirmPickUpDate")
            <b>{{ $t('offer.instructions.departure.harbor.departureAt') }}</b> {{ transit.departure.date | moment($i18n.locale) }}
          p.m-0(v-if="reply2.departure.depositDate && !reply2.departure.confirmPickUpDate")
            <b>{{ $t('offer.instructions.departure.harbor.departureAt') }}</b> {{ reply2.departure.depositDate | moment($i18n.locale) }}

      //- Arrival addresses
      h6.mb-2.mt-3.title-adress {{ $t('offer.instructions.arrival.shipment') }}
      .d-flex
        .add-content(v-if="reply2.arrival.confirmHarbor")
          p.m-0
            <b>{{ $t('form.harbor') | dots($i18n.locale) }}</b> {{ transit.arrival.address.city }}
          p.m-0
            <b>{{ $t('form.country') | dots($i18n.locale) }}</b> {{ country(transit.arrival.address.country) }}
          //- p.m-0
          //-   <b v-if="reply2.arrival.harborInstruction">{{ $t('offer.instructions.arrival.delivery') | dots($i18n.locale) }}</b>  {{ reply2.arrival.harborInstruction }}
          p.m-0(v-if="reply2.arrival.arrivalDate")
            <b>{{ $t('offer.instructions.arrival.deliveryAt') }}</b> {{ reply2.arrival.arrivalDate | moment($i18n.locale) }}
        .add-content(v-else)
          p.m-0
            <b>{{ $t('form.harbor') | dots($i18n.locale) }}</b> {{ reply2.arrival.harbor.city }}
          p.m-0
            <b>{{ $t('form.country') | dots($i18n.locale) }}</b> {{ country(reply2.arrival.harbor.country) }}
          //- p.m-0
          //-   <b>{{ $t('offer.instructions.arrival.delivery') | dots($i18n.locale) }}</b> {{ reply2.arrival.harbor.instruction }}
          p.m-0(v-if="reply2.arrival.arrivalDate")
            <b>{{ $t('offer.instructions.arrival.deliveryAt') }}</b> {{ reply2.arrival.arrivalDate | moment($i18n.locale) }}
    b-col(
      md="5",
      style="display: flex; justify-content: center; align-items: center; flex-direction: column"
    )
      .price-div2 {{ $t('offer.payment.label') }} {{ $t('offer.payment.amount', { amount: reply2.price.totalWithVccTtc, currency: reply2.price.currency }) }}
      span(style="margin: 5px 0;max-width: 225px !important;text-align: center;font-size: 12px;") {{ $t('offer.payment.commission', { comm: reply2.price.vvcComissionTtc }) }}
      button.action-button-offer.mt-2(
        @click="downloadProforma"
        :disabled="pendingProforma"
        v-if="transit.open && reply2.status!='WIN'"
      ) 
        <svg v-if="pendingProforma" class="load-ico" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="24" height="24" viewBox="0 0 172 172" style=" fill:#000000;"><g fill="none" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt" stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0" font-family="none" font-weight="none" font-size="none" text-anchor="none" style="mix-blend-mode: normal"><path d="M0,172v-172h172v172z" fill="none"></path><g fill="#ffffff"><path d="M53.75,28.66667c-9.8951,0 -17.91667,8.02156 -17.91667,17.91667c0,9.8951 8.02156,17.91667 17.91667,17.91667c9.8951,0 17.91667,-8.02156 17.91667,-17.91667c0,-9.8951 -8.02156,-17.91667 -17.91667,-17.91667zM93.16667,28.66667c-3.95804,0 -7.16667,3.20863 -7.16667,7.16667c0,3.95804 3.20863,7.16667 7.16667,7.16667c3.95804,0 7.16667,-3.20863 7.16667,-7.16667c0,-3.95804 -3.20863,-7.16667 -7.16667,-7.16667zM129,43c-3.95804,0 -7.16667,3.20863 -7.16667,7.16667c0,3.95804 3.20863,7.16667 7.16667,7.16667c3.95804,0 7.16667,-3.20863 7.16667,-7.16667c0,-3.95804 -3.20863,-7.16667 -7.16667,-7.16667zM35.83333,78.83333c-7.91608,0 -14.33333,6.41725 -14.33333,14.33333c0,7.91608 6.41725,14.33333 14.33333,14.33333c7.91608,0 14.33333,-6.41725 14.33333,-14.33333c0,-7.91608 -6.41725,-14.33333 -14.33333,-14.33333zM143.33333,78.83333c-3.95804,0 -7.16667,3.20863 -7.16667,7.16667c0,3.95804 3.20863,7.16667 7.16667,7.16667c3.95804,0 7.16667,-3.20863 7.16667,-7.16667c0,-3.95804 -3.20863,-7.16667 -7.16667,-7.16667zM132.58333,114.66667c-5.93706,0 -10.75,4.81294 -10.75,10.75c0,5.93706 4.81294,10.75 10.75,10.75c5.93706,0 10.75,-4.81294 10.75,-10.75c0,-5.93706 -4.81294,-10.75 -10.75,-10.75zM53.75,121.83333c-5.93706,0 -10.75,4.81294 -10.75,10.75c0,5.93706 4.81294,10.75 10.75,10.75c5.93706,0 10.75,-4.81294 10.75,-10.75c0,-5.93706 -4.81294,-10.75 -10.75,-10.75zM96.63802,129c-5.93706,0 -10.75,4.81294 -10.75,10.75c0,5.93706 4.81294,10.75 10.75,10.75c5.93706,0 10.75,-4.81294 10.75,-10.75c0,-5.93706 -4.81294,-10.75 -10.75,-10.75z"></path></g></g></svg>
        span {{ pendingProforma ? $t('offer.payment.cta.devis') : $t('offer.payment.cta.devis') }}
      button.action-button-offer.mt-1(
        v-if="transit.open && reply2.status!='WIN'",
        @click="onSelectButton"
      ) {{ selectedR ? $t('offer.payment.cta.deselect') : $t('offer.payment.cta.select') }}
  TransitionExpand
    OfferPending.mt-5(v-if="selectedR" :reply="reply2" :id="'001'" @closeTransit="closeTransit")
</template>

<script>
import TransitMixin from "@/mixins/Transit";
import OfferPending from './OfferPending';
import TransitionExpand from '@/components/ui/TransitionExpand';
import { mapState } from "vuex";
import { Auth } from 'aws-amplify'

export default {
  name: "OfferInstructions",
  mixins: [TransitMixin],
  components: {
    OfferPending,
    TransitionExpand
  },
  props: {
    transit: {
      type: Object,
    },
    reply2: {
      type: Object,
    },
    title: {
      type: String,
      default: "Notre offre pour vous",
    },
    selectedR: {
      type: Boolean,
      default: false,
    },
    index : {
      type: Number,
      default : 1,
    },
    pending: Boolean,
  },
  data() {
    return {
      pendingProforma : false,
    };
  },
  methods: {
    getMobileOS () {
      const ua = navigator.userAgent
      if (/android/i.test(ua)) {
        return "Android"
      }
      else if ((/iPad|iPhone|iPod/.test(ua)) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)){
        return "iOS"
      }
      return "Other"
    },
    closeTransit(){
      this.$store.dispatch('closeTransit', this.transit)
    },
    onSelectButton (event) {
      this.$emit('selected')
    },
    async downloadProforma() {
      this.pendingProforma = true;
      if(this.reply2.userProformaId){
          this.downloadProformaBill(this.reply2.userProformaId);
      }else{
      await fetch(
        `${process.env.VUE_APP_API_BASE_URL}/transit/${this.reply2.transitId}/reply/${this.reply2.replyId}/proforma`,
        {
          headers: {
            Authorization: `Bearer ${(await Auth.currentSession()).getAccessToken().getJwtToken()}`,
          },
          method: "GET",
        }
      ).then((response) => response.json())
      .then((data) => {
          this.downloadProformaBill(data.proformaId);
      })
      .catch((e) => {
          console.error(`Error during get the bllling url`, e);
          this.$notify({
            type: "error",
            group: "default",
            title: this.$t("notifications.transit.proforma.downloadError"),
            text: this.$t("notifications.genericError"),
            duration: 5000,
          });
          this.pendingProforma = false;
        });
      }
    },
    async downloadProformaBill(proformaId) {
      await fetch(
        `${process.env.VUE_APP_API_BASE_URL}/billing/${proformaId}/download`,
        {
          headers: {
            Authorization: `Bearer ${(await Auth.currentSession()).getAccessToken().getJwtToken()}`,
          },
          method: "GET",
        }
      )
        .then((response) => response.json())
        .then((data) => {
          console.log('im here');
          localStorage.linkFile=data.url;
          if(this.getMobileOS()!='iOS'){
            let routeData = this.$router.resolve({name: 'files'});
            window.open(routeData.href, '_blank');
          } else {
            this.$router.replace({ name: 'files' }).catch(() => {})
          }
          // window.open(data.url, "_blank");
          this.pendingProforma = false;
        })
        .catch((e) => {
          console.error(`Error during get the bllling url`, e);
          this.$notify({
            type: "error",
            group: "default",
            title: this.$t("notifications.transit.proforma.downloadError"),
            text: this.$t("notifications.genericError"),
            duration: 5000,
          });
          this.pendingProforma = false;
        });
    },
  },
  computed : {
    ...mapState(["currentUser"]),
    replyDepartureAtHome() {
      return this.reply2.departure.supported === 'home'
    },
    replyDepartureAtHarbor() {
      return this.reply2.departure.supported === 'harbor'
    },
  }
};
</script>

<style>
.offer-div {
  border: 2px solid #3333330d;
  background-color: #d3d4d414;
  border-radius: 5px;
  padding: 12px 5px;
  width: 100%;
  margin-bottom: 10px;
  position: relative !important;
}
.offer-div:last-child {
  margin-bottom: unset;
}
.offer-title {
  min-width: 170px;
  width: 100%;
  text-align: center;
  background-color: #a432460d;
  border: 2px solid #f1f1f1;
  color: #a43246;
  padding: 10px;
  font-size: 16px;
  font-weight: 600;
  border-radius: 5px 0 5px 0;
  margin-top: -2px;
  margin-left: -17px;
  /* margin-bottom: 10px; */
}
.title-adress {
  font-size: 16px;
  color: #a43246;
  margin-bottom: 0 !important;
}
.add-content {
  padding-left: 5px;
  border-left: 3px dashed #a63346;
  max-width: 100% !important;
}
.price-div {
  font-size: 24px;
  font-weight: 700;
  color: #a43246;
}
.price-div2 {
  font-size: 21px;
  font-weight: 700;
  color: #a43246;
  padding-top: 13px;
}
.action-button-offer {
  border-radius: 5px !important;
  background-color: #fcfcfc;
  color: #a43246;
  border: 1px solid #a43246;
  font-weight: 500;
  padding: 5px 25px !important;
  min-width: 80%;
  transition: all 0.3s;
  font-size: 12px;
  font-weight: 600;
  /* opacity: 0; */
}
.action-button-offer:hover {
  border-radius: 5px !important;
  background-color: #a43246;
  color: #ffffff;
  font-weight: 600;
  border: 1px solid #a43246;
  transition: all 0.3s;
}
.action-button-offer:disabled {
  cursor: wait;
}
/* .action-button-offer:active {
  border-radius: 5px !important;
  background-color: #a43246;
  color: #ffffff;
  font-weight: 600;
  border: 1px solid #a43246;
  transform: translateY(1px);
  transition: all 0.3s;
} */
.f-col {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding-right: 7px;
  
}
  @media only screen and (min-width: 768px){
    .f-col {
      transform: rotate(270deg);
    }
  }
/* .offer-div:hover .action-button-offer {
  transition: all 0.5s;
  opacity: 0;
} */
.ribbon {
  width: 146px;
  height: 114px;
  overflow: hidden;
  position: absolute;
  z-index: 1;
  border-radius: 4px;
}
.ribbon::before,
.ribbon::after {
  position: absolute;
  z-index: -1;
  content: '';
  display: block;
  border: 3px solid #a43246;
}
.ribbon div {
  position: absolute;
  display: block;
  width: 221px;
  padding: 8px 0;
  background-color: #a43246;
  box-shadow: 0 5px 10px rgba(0,0,0,.1);
  color: #fff;
  font: 700 18px/1 'Lato', sans-serif;
  text-shadow: 0 1px 1px rgba(0,0,0,.2);
  /* text-transform: uppercase; */
  text-align: center;
}

.ribbon-top-right {
  top: -7px;
  right: -7px;
}
.ribbon-top-right::before,
.ribbon-top-right::after {
  border-top-color: transparent;
  border-right-color: transparent;
}
.ribbon-top-right::before {
  top: 0;
  left: 0;
}
.ribbon-top-right::after {
  bottom: 0;
  right: 0;
}
.ribbon-top-right div {
  left: -25px;
  top: 30px;
  transform: rotate(38deg);
}
.offerSelected{
  box-shadow: 0 0 8px #a4324647;
  border-color: #ffffff1a !important;
}
.svg-badge-ico{
  margin-top: -8px;
  margin-bottom: -15px;
  margin-right: -3px;
}
.badge-text{
  margin-right: 3px;
}
</style>